import axios from "axios";
import { Buffer } from 'buffer';
import { useEffect, useState } from "react";

const useImageFetch = (url) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const images = []
    const fetchData = async () => {
        for (let i = 0; i < 4; i++) {
            const image = await axios.get(`${url}/${Math.round(Math.random() * 1000)}`);
            const buffer = new Buffer(image.data);
            images.push(buffer.toString("base64"));
        }
        setData(images);
        setLoading(false);
    }
    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url])

    return { isLoading: loading, avatars: data }
}

export default useImageFetch